import React, {Component} from 'react';

class Article extends Component {


    render() {
        return (

            <div id="article" className="row home-block">

                <h2 className="title">Base de données</h2>
                <h3>Intervenante</h3>
                <p><a href="/#Menu">Emmanuelle Claeys</a></p>
                <h3>Description</h3>
                <p>Le but de ce <a
                    href="https://github.com/manuclaeys/unistra_m1stat_base_de_donnees/blob/master/Session%201-20200422/pr%C3%A9sentation.pdf"> cours</a> est
                    de comprendre les conceptes interviennent en Base de données Relationnelle.<br/>
                    La théorie portera sur les SGBD, le language SQL et la modélisation et concepts relationnels<br/>
                    Les TD vous permetteront de savoir comment mettre en place et administrer une base de
                    données.<br/><br/>
                    Vous devriez, à la fin de ce cours, comprendre le travail d'un <span className="italique">concepteur ou administrateur d'une bases de données</span>.
                </p>

                <h3>Cours et slides</h3>
                <li> Cours 1 <a
                    href="https://github.com/manuclaeys/unistra_m1stat_base_de_donnees/blob/master/Session%201-20200422/bdd_cour_n_1.pdf">Présentation
                    des SGBDR</a>
                </li>
                <li> Cours 2.1 <a
                    href="https://github.com/manuclaeys/unistra_m1stat_base_de_donnees/blob/master/Session%202-20200422/selection.pdf">Sélection
                    dans une base de données</a>
                </li>
                <li> Cours 2.2 <a
                    href="https://github.com/manuclaeys/unistra_m1stat_base_de_donnees/blob/master/Session%202-20200422/index.pdf">Index</a>
                </li>
                <li> Cours 3 <a
                    href="https://github.com/manuclaeys/unistra_m1stat_base_de_donnees/blob/master/Session%203-20200422/cle_primaire_etrangere.pdf">Les
                    clés primaires et étrangères</a>
                </li>
                <li> Cours 4 <a
                    href="https://github.com/manuclaeys/unistra_m1stat_base_de_donnees/blob/master/Session%204%20-20200422/modelisation.pdf">Modèle
                    entité-association</a>
                </li>
                <li> Cours 5 <a
                    href="https://github.com/manuclaeys/unistra_m1stat_base_de_donnees/blob/master/Session%205-20200422/jointures.pdf">Jointure</a>
                </li>
                <li> Cours 6 <a
                    href="https://github.com/manuclaeys/unistra_m1stat_base_de_donnees/blob/master/Session%206-20200422/sous-reque%CC%82tes.pdf">Sous-requête</a>
                </li>


                <h3>Travaux dirigés</h3>


                <li> Session 1
                    <ul>
                        <a href="https://github.com/manuclaeys/unistra_m1stat_base_de_donnees/blob/master/Session%201-20200422/installation.pdf">Prise
                            en main et installation de MySQL</a>
                    </ul>
                    <ul>
                        <a href="https://github.com/manuclaeys/unistra_m1stat_base_de_donnees/blob/master/Session%201-20200422/td_1.pdf">TD1</a>
                    </ul>
                    <ul>
                        <a href="https://github.com/manuclaeys/unistra_m1stat_base_de_donnees/blob/master/Session%201-20200422/td_2.pdf">TD2</a>
                    </ul>
                    <ul>
                        <a href="https://github.com/manuclaeys/unistra_m1stat_base_de_donnees/blob/master/Session%201-20200422/td_3.pdf">TD3</a>
                    </ul>
                    <ul>
                        <a href="https://github.com/manuclaeys/unistra_m1stat_base_de_donnees/blob/master/Session%201-20200422/TD_1.csv">Données
                            (csv)</a>
                    </ul>
                    <ul>
                        <a href="https://github.com/manuclaeys/unistra_m1stat_base_de_donnees/blob/master/Session%201-20200422/TD_animal.sql">Données
                            (SQL)</a>
                    </ul>
                    <ul>
                        <a href="https://github.com/manuclaeys/unistra_m1stat_base_de_donnees/blob/master/Session%201-20200422/session1.sql">Correction</a>
                    </ul>
                </li>


                <li> Session 2
                    <ul>
                        <a href="https://github.com/manuclaeys/unistra_m1stat_base_de_donnees/blob/master/Session%202-20200422/td_4.pdf">TD4</a>
                    </ul>
                    <ul>
                        <a href="https://github.com/manuclaeys/unistra_m1stat_base_de_donnees/blob/master/Session%202-20200422/td_5.pdf">TD5</a>
                    </ul>
                    <ul>
                        <a href="https://github.com/manuclaeys/unistra_m1stat_base_de_donnees/blob/master/Session%202-20200422/session2.sql">Correction</a>
                    </ul>
                </li>

                <li> Session 3
                    <ul>
                        <a href="https://github.com/manuclaeys/unistra_m1stat_base_de_donnees/blob/master/Session%203-20200422/TD_6.pdf">TD6</a>
                    </ul>
                    <ul>
                        <a href="https://github.com/manuclaeys/unistra_m1stat_base_de_donnees/blob/master/Session%203-20200422/session3.sql">Correction</a>
                    </ul>
                </li>

                <li> Session 4
                    <ul>
                        <a href="https://github.com/manuclaeys/unistra_m1stat_base_de_donnees/blob/master/Session%204%20-20200422/TD_7.pdf">TD7</a>
                    </ul>
                    <ul>
                        <a href="https://github.com/manuclaeys/unistra_m1stat_base_de_donnees/blob/master/Session%203-20200422/session3.sql">Correction</a>
                    </ul>
                </li>

                <li> Session 5
                    <ul>
                        <a href="https://github.com/manuclaeys/unistra_m1stat_base_de_donnees/blob/master/Session%205-20200422/td_8.pdf">TD8</a>
                    </ul>
                    <ul>
                        <a href="https://github.com/manuclaeys/unistra_m1stat_base_de_donnees/blob/master/Session%205-20200422/TD_8.sql">Correction</a>
                    </ul>
                </li>

                <li> Session 6
                    <ul>
                        <a href="https://github.com/manuclaeys/unistra_m1stat_base_de_donnees/blob/master/Session%206-20200422/TD_9.pdf">TD9</a>
                    </ul>
                    <ul>
                        <a href="https://github.com/manuclaeys/unistra_m1stat_base_de_donnees/blob/master/Session%206-20200422/TD9.sql">Correction</a>
                    </ul>
                </li>


                <h3>Examen</h3>
                <li><a
                    href="https://github.com/manuclaeys/unistra_m1stat_base_de_donnees/blob/master/examen/projet_sujet.pdf">Sujet
                    du projet</a>
                </li>
                <li><a
                    href="https://github.com/manuclaeys/unistra_m1stat_base_de_donnees/blob/master/examen/base-tennis.sql">BDD
                    Base de tennis</a>
                </li>
                <li><a
                    href="https://github.com/manuclaeys/unistra_m1stat_base_de_donnees/blob/master/examen/cinema.sql">BDD
                    Cinéma</a>
                </li>
                <li><a href="https://github.com/manuclaeys/unistra_m1stat_base_de_donnees/blob/master/examen/monde.sql">BDD
                    Monde</a>
                </li>
                <li><a
                    href="https://github.com/manuclaeys/unistra_m1stat_base_de_donnees/blob/master/examen/MemoSQL.pdf">Mémo</a>
                </li>

                <h3>Bibliographie</h3>
                <li><a
                    href="https://github.com/manuclaeys/unistra_m1stat_base_de_donnees/blob/master/Session%204%20-20200422/modeliser-guide.pdf">
                    <em> Modèlisation des données par Michel Auguste</em></a></li>
                <li>Administrez vos bases de données avec MYSQL<em> C. Gribaumont </em></li>
                <li>OpenClassrooms</li>


                <h3>Retours étudiants</h3>
                <li> Les retours des étudiants sont visibles sur <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSeins5Cpcu4WdaGFKeKp5pBcatzpfBwijb3ShgjcZL041SAOg/viewanalytics">ce
                    lien</a>.
                </li>


            </div>

        );
    }
}

export default Article;



// WEBPACK FOOTER //
// ./src/Components/CoursBaseDeDonnees2019/index.js